<div class="tabs-container">
    <div class="box">
        <i class="fa fa-angle-left tab-arrow"></i>
        <div class="nav-tabs-wrap">
            <ul class="nav nav-tabs">
                <li *ngFor="let tab of tabs" [ngClass]="{'active': isActiveTab(tab.id) }" (click)="selectTab(tab)">
                    <a>{{tab.title}}</a>
                </li>
            </ul>
        </div>
        <i class="fa fa-angle-right tab-arrow"></i>
    </div>
    <div class="tab-content">
        <ng-content></ng-content>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/item-view/tabs/tabs-wrapper/tabs-wrapper-property.component.html